<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important; text-align: right">شناسایی نیازها وانتظارات ذینفعان</h2>
            </div>
            <form class="needs-validation mt-2 mb-3" novalidate>
              <div class="row">
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">منبع نیاز</label>
                  <select class="form-select" name="" id="">
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option value="فرآیند">فرآیند</option>
                    <option value="ذی نفع">ذی نفع</option>
                  </select>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">ذی نفع</label>
                  <input class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">گروه فرآیند</label>
                  <input class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">فرآیند</label>
                  <input class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">زیر فرآیند</label>
                  <input class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">ورودی/خروجی</label>
                  <select class="form-select" name="" required>
                    <option value="">ورودی</option>
                    <option value="">خروجی</option>

                  </select>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">شرح ورودی / خروجی</label>
                  <input class="form-control" type="text" name="" required>
                </div>
              </div>
              <div class="row">

                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">نیازهای اساسی</label>
                  <input class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">نوع نیاز</label>
                  <select class="form-select" name="" required>
                    <option value="">چگونگی</option>
                    <option value="Dallas">چه میزانی</option>

                  </select>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">نیازهای عملکردی</label>
                  <input class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-1">
                  <label class="form-label">نیازهای انگیزشی</label>
                  <input class="form-control" type="text" name="" required>
                </div>
              </div>
              <div class="row">



                <div class="col-lg-5 mb-3 ms-n-1">&nbsp</div>
                <div class="col-lg-1 mb-3">
                  <button class="btn btn-primary btn-submit-1" type="submit" style="margin-top: 1.9vw;">ثبت</button>
                </div>
              </div>
            </form>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>ذی نفع</th>
                  <th>فرآیند</th>
                  <th>شرح ورودی / خروجی</th>
                  <th>نیازهای اساسی</th>
                  <th>نیازهای عملکردی</th>
                  <th>نیازهای انگیزشی</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td scope="row">1</td>
                  <td>دسته 1</td>
                  <td>عنوان 1</td>
                  <td>title 1</td>
                  <td>۰۱-۰۱ گروه</td>
                  <td>10031</td>
                  <td>10031</td>
                  <td>
                    <a href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
                    <a style="margin-right: 1vw;" href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
                  </td>
                </tr>
                <tr>
                  <td scope="row">&nbsp</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td scope="row">&nbsp</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td scope="row">&nbsp</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td scope="row">&nbsp</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td scope="row">&nbsp</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="form-buttons row mt-4 mb-5 d-flex justify-content-center">
              <button class="btn btn-primary btn-submit-1 m-2" type="submit">ذخیره</button>
              <button class="btn btn-primary btn-back m-2" type="submit">بازگشت</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar";
import Splash from "@/components/Splash/Splash";
export default {
  name: "beneficiary_id",
  components: {Splash, Sidebar}
}
</script>

<style scoped>
.row{
  padding: .5vw;
}
</style>